module.exports = __webpack_public_path__ + "static/media/GlaucoDamas.a0a6cd9b.jpeg";